import { animate, scroll } from "motion"

/**
 * Handles background image scaling in parallax block
 * @param {Object} element - Block
 */
export const parallaxHandler = (element) => {
  // const {
  //   top: t,
  //   left: l
  // } = element.getBoundingClientRect()

  // // Compute element position relative to the top of the document
  // const body = document.body;
  // const animationStartOffset = 50;
  // let scrollTop = window.pageYOffset || element.scrollTop || body.scrollTop;
  // let clientTop = element.clientTop || body.clientTop || 0;
  // let elementTopPosition = t + scrollTop - clientTop;

  // // In case page is reloaded after having scrolled, adjust image scale accordingly
  // let scrollPosition = window.scrollY;
  // let scaleFactor = scrollPosition > elementTopPosition - animationStartOffset ? (scrollPosition - elementTopPosition) / 25 : 0
  // element.style.backgroundSize = 100 + scaleFactor + '%'
  // // On scroll, adjust image scale accordingly
  // window.addEventListener('scroll', () => {
  //   let scrollPosition = window.scrollY;
  //   let scaleFactor = scrollPosition > elementTopPosition - animationStartOffset ? (scrollPosition - elementTopPosition) / 25 : 0
  //   element.style.backgroundSize = 100 + scaleFactor + '%'
  // })

  const scrollOptions = {
    target: element,
    offset: ["50% end", "end start"]
  }

  scroll(
    animate(element, { backgroundSize: ["100%", "150%"] }),
    scrollOptions
  );
}

/**
 * TODO: Stop animation after sufficient scrolling
 */